/**
 * Variant Utilities
 *
 * Shared utility functions for formatting variant attributes
 * Used by StockUpdateModal and PriceUpdateModal
 */

/**
 * Format variant attribute key to human-readable label
 * Examples:
 * - "color_family" → "Color Family"
 * - "color-family" → "Color Family"
 * - "size" → "Size"
 */
export const formatAttributeKey = (key: string): string => {
  return key
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

/**
 * Format variant tier variations to human-readable string
 * @param tierVariation Array of tier variation objects
 * @param includeKeys If true, includes key names (e.g., "Color Family: Silver")
 *                    If false, only values (e.g., "Silver")
 */
export const formatVariantName = (
  tierVariation: Array<Record<string, string>> | undefined,
  includeKeys: boolean = true
): string => {
  if (!tierVariation || tierVariation.length === 0) {
    return "No attributes";
  }

  return tierVariation
    .map((attr) =>
      Object.entries(attr)
        .map(([key, value]) =>
          includeKeys ? `${formatAttributeKey(key)}: ${value}` : String(value)
        )
        .join(", ")
    )
    .join(" | ");
};
